import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SharedModule } from '../shared/shared.module';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BlockUIModule } from 'primeng/blockui';
import { ButtonModule } from 'primeng/button';
import { ContextMenuModule } from 'primeng/contextmenu';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { TreeModule } from 'primeng/tree';
import { TreeTableModule } from 'primeng/treetable';
import { AppNavbarComponent } from './app-navbar/app-navbar.component';
import { EditTableComponent } from './edit-table/edit-table.component';
import { EditToolbarComponent } from './edit-toolbar/edit-toolbar.component';
import { EditTreeComponent } from './edit-tree/edit-tree.component';
import { FooterComponent } from './footer/footer.component';
import { FormFieldsExplorerComponent } from './form-fields-explorer/form-fields-explorer.component';
import { FormSelectComponent } from './form-select/form-select.component';
import { SelectUserComponent } from './select-user/select-user.component';
import { TemplateSelectComponent } from './template-select/template-select.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    TableModule,
    TreeModule,
    TreeTableModule,
    ContextMenuModule,
    ButtonModule,
    FontAwesomeModule,
    AutoCompleteModule,
    InputSwitchModule,
    BlockUIModule,
    InputTextModule,
    ButtonModule,
    SharedModule,
  ],
  declarations: [
    AppNavbarComponent,
    FooterComponent,
    EditToolbarComponent,
    EditTableComponent,
    EditTreeComponent,
    FormSelectComponent,
    FormFieldsExplorerComponent,
    TemplateSelectComponent,
    SelectUserComponent
  ],
  exports: [
    AppNavbarComponent,
    FooterComponent,
    EditToolbarComponent,
    EditTableComponent,
    EditTreeComponent,
    FormSelectComponent,
    FormFieldsExplorerComponent,
    TemplateSelectComponent,
    AutoCompleteModule,
    InputSwitchModule,
    BlockUIModule,
    TableModule,
    InputTextModule,
    ButtonModule,
  ]
})
export class UiModule { }
